import RodadaEntity from "entity/Rodada";
import { copiarInscritosDeRodada } from "entity/Inscricao/copiarInscritos";

/**
 * Duplica uma rodada completa, incluindo todos os seus inscritos.
 *
 * Cria uma nova rodada com os mesmos dados da original, ajustando:
 * - Remove UID (gera novo)
 * - Adiciona " (Cópia)" ao nome
 * - Reseta status para ATIVO
 * - Limpa possiveisReunioes (serão regeneradas)
 * - Limpa datas de controle
 *
 * Depois copia todos os inscritos para a nova rodada.
 *
 * @param {object} rodadaOrigem - Objeto completo da rodada a ser duplicada
 * @returns {Promise<{ rodadaUid: string, rodadaNome: string, inscritos: { copiados: number, ignorados: number } }>}
 */
export async function duplicarRodada(rodadaOrigem) {
    // 1. Preparar dados da nova rodada
    const novaRodada = JSON.parse(JSON.stringify(rodadaOrigem));

    // Remover UID para gerar um novo
    delete novaRodada.uid;

    // Ajustar nome
    novaRodada.nome = rodadaOrigem.nome + " (Cópia)";

    // Manter status ativo
    novaRodada.status = "ATIVO";

    // Limpar possiveisReunioes (dependem de horários/mesas específicos)
    novaRodada.possiveisReunioes = [];

    // Limpar datas de controle
    delete novaRodada.dataLastChange;
    delete novaRodada.dataLastChangeStr;
    delete novaRodada.dataLastChangeServer;
    delete novaRodada.userLastChange;

    // 2. Salvar a nova rodada
    const entity = new RodadaEntity();
    entity.update(novaRodada);
    await entity.save();

    const novaRodadaUid = entity.data.uid;
    const novaRodadaNome = entity.data.nome;

    // 3. Copiar inscritos da rodada original para a nova
    let resultadoInscritos = { copiados: 0, ignorados: 0, semInscritos: true };

    try {
        resultadoInscritos = await copiarInscritosDeRodada(rodadaOrigem.uid, {
            uid: novaRodadaUid,
            nome: novaRodadaNome,
        });
    } catch (error) {
        console.error("Erro ao copiar inscritos durante duplicação:", error);
        // A rodada já foi criada, então retornamos o resultado parcial
    }

    return {
        rodadaUid: novaRodadaUid,
        rodadaNome: novaRodadaNome,
        inscritos: resultadoInscritos,
    };
}
